import { Injectable } from "@angular/core";
import {
    Router,
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
} from "@angular/router";
import { AuthService } from "src/app/services/auth.service";

@Injectable({
    providedIn: "root",
})
export class AuthGuard implements CanActivate {

    constructor(
        private authService: AuthService,
        private router: Router
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {

        const currentUser = this.authService.currentUserValue;

        if (currentUser) {
            return true;
        }

        this.router.navigate(['/authentication/signin'], {
            queryParams: { returnUrl: state.url }
        });

        return false;
    }
}
